import styled from "styled-components";

export const Sekcja = styled.section`
  background: ${({$compact})=>$compact ? "#fff" : "#f5efe1"};
  margin: 0 auto;
  padding: ${({$compact})=>$compact ? "32px" : "88px"} clamp(16px, 5vw, 72px);
  @media (max-width: 767px) { padding-top: ${({$compact})=>$compact ? "24px" : "64px"}; padding-bottom: 40px; }
  .review-summary { max-width: 880px; margin: -14px auto 24px; color: #535853; font-size: 17px; line-height: 1.6; text-align: center; }
`;

export const Summary = styled.div`
  display: grid; grid-template-columns: 1fr auto auto; gap: 28px; align-items: end; max-width: 1180px; margin: 0 auto 34px;
  p { margin: 0 0 8px; color: ${({ theme }) => theme.color.green}; font-size: 13px; font-weight: 900; letter-spacing: .09em; text-transform: uppercase; }
  h2 { margin: 0; }
  @media (max-width: 760px) { grid-template-columns: 1fr; align-items: start; gap: 14px; }
`;
export const Score = styled.div`display: grid; gap: 2px; strong { font-size: 30px; } span { color: #646964; font-size: 13px; }`;
export const ReviewsLink = styled.a`
  position: relative; pointer-events: auto; display: inline-flex; align-items: center; justify-content: center; min-height: 48px; padding: 10px 20px; border-radius: 999px;
  background: ${({ theme }) => theme.color.green}; color: #fff; font-weight: 900; line-height: 1.25; text-align: center; text-decoration: none;
  &:hover { filter: brightness(.93); }
`;

export const Kontener = styled.div`max-width:1180px; margin:0 auto;`;
export const Viewport = styled.div`overflow:hidden; padding:4px 0 16px; touch-action:pan-y;`;
export const Track = styled.div`
 display:flex; align-items:flex-start; gap:16px;
 transform:translateX(calc(-${({$index,$perPage}) => $index*100/$perPage}% - ${({$index,$perPage}) => $index*16/$perPage}px));
 transition:transform 600ms ease;
 @media(prefers-reduced-motion:reduce){transition:none;}
`;
export const Controls = styled.div`
 display:flex; justify-content:center; align-items:center; gap:16px;
 > button { min-height:44px; cursor:pointer; color:#1c5d27; background:white; border:1px solid #d8ddd8; border-radius:24px; padding:8px 16px; font:inherit; font-size:13px; }
`;
export const ReadMore = styled.button`margin-top:auto; align-self:flex-start; min-height:44px; padding:8px 6px; background:none; border:0; color:#1c5d27; font:inherit; font-size:14px; font-weight:800; cursor:pointer;`;

export const Strzalka = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0 10px;
  width: 44px;
  min-height: 44px;
  color: #1c5d27;
  border-radius: 50%;
  &:focus-visible { outline: 3px solid #ffad00; }
`;

export const Karta = styled.div`
  background: #fff;
  border-radius: 22px;
  margin: 0;
  padding: 10px;
  flex: 0 0 calc((100% - ${({$perPage}) => ($perPage - 1) * 16}px) / ${({$perPage}) => $perPage});
  min-width: 0;
  min-height: 275px;
  border: 1px solid rgba(29, 29, 27, 0.08);
  box-shadow: 0 16px 40px rgba(36, 49, 38, 0.09);
  max-width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    min-height: 250px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    min-height: 290px;
  }
`;

export const Tytul = styled.div`
  background: #f0f5ef;
  color: #1c5d27;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px;
  border-top-left-radius: 21px;
  border-top-right-radius: 21px;
  margin: -10px -10px 10px -10px;
`;

export const Ikona = styled.span`
  display: grid;
  place-items: center;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background: #fff;
  color: #4285f4;
  font-weight: 900;
`;

export const Autor = styled.p`
  margin: 0;
  font-weight: bold;
`;

export const Gwiazda = styled.img`
  width: 16px;
  height: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    width: 14px;
    height: 14px;
  }
`;

export const Opinia = styled.p`
  display:-webkit-box; -webkit-box-orient:vertical; -webkit-line-clamp:${({$expanded}) => $expanded ? "unset" : 6}; overflow:hidden;
  font-size: 14px;
  line-height: 1.55;
  margin-top: 0;
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 30px;
`;

export const Dot = styled.button`
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  margin: 0 5px;
  border-radius: 50%;
  background-color: ${(props) => (props.$active ? "#1c5d27" : "#9ba19b")};
  border: 9px solid #f5efe1;
  cursor: pointer;
`;

export const Wstep = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

